import React from 'react';
import styles from './stack.module.css';
import { BOOK_TITLES } from '../../../constants';

const STACK_TOPICS = [
  {
    id: 'stack-1',
    label: '01',
    tierClass: styles.tierFuture,
    iconClass: styles.iconCyan,
    title: 'Будущее и мы в нём',
    blocks: [
      {
        subtitle: 'Миры завтрашнего дня',
        text: 'Научная фантастика, антиутопии и тексты, где будущее — это полигон для мысли о настоящем.',
        tags: ['Жук в муравейнике', 'Пища богов'],
      },
      {
        subtitle: 'Последствия и системы',
        text: 'Что произошло, почему так получилось, за что нам всё это. И как с задором проворачивать такое же в жизни.',
        tags: ['ГПиМРМ', 'Задача трёх тел'],
      },
    ],
    icon: (
      <svg width="32" height="32" viewBox="64 64 896 896" fill="currentColor">
  <path d="M924.8 385.6a446.7 446.7 0 00-96-142.4 446.7 446.7 0 00-142.4-96C631.1 123.8 572.5 112 512 112s-119.1 11.8-174.4 35.2a446.7 446.7 0 00-142.4 96 446.7 446.7 0 00-96 142.4C75.8 440.9 64 499.5 64 560c0 132.7 58.3 257.7 159.9 343.1l1.7 1.4c5.8 4.8 13.1 7.5 20.6 7.5h531.7c7.5 0 14.8-2.7 20.6-7.5l1.7-1.4C901.7 817.7 960 692.7 960 560c0-60.5-11.9-119.1-35.2-174.4zM761.4 836H262.6A371.12 371.12 0 01140 560c0-99.4 38.7-192.8 109-263 70.3-70.3 163.7-109 263-109 99.4 0 192.8 38.7 263 109 70.3 70.3 109 163.7 109 263 0 105.6-44.5 205.5-122.6 276zM623.5 421.5a8.03 8.03 0 00-11.3 0L527.7 506c-18.7-5-39.4-.2-54.1 14.5a55.95 55.95 0 000 79.2 55.95 55.95 0 0079.2 0 55.87 55.87 0 0014.5-54.1l84.5-84.5c3.1-3.1 3.1-8.2 0-11.3l-28.3-28.3zM490 320h44c4.4 0 8-3.6 8-8v-80c0-4.4-3.6-8-8-8h-44c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8zm260 218v44c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8v-44c0-4.4-3.6-8-8-8h-80c-4.4 0-8 3.6-8 8zm12.7-197.2l-31.1-31.1a8.03 8.03 0 00-11.3 0l-56.6 56.6a8.03 8.03 0 000 11.3l31.1 31.1c3.1 3.1 8.2 3.1 11.3 0l56.6-56.6c3.1-3.1 3.1-8.2 0-11.3zm-458.6-31.1a8.03 8.03 0 00-11.3 0l-31.1 31.1a8.03 8.03 0 000 11.3l56.6 56.6c3.1 3.1 8.2 3.1 11.3 0l31.1-31.1c3.1-3.1 3.1-8.2 0-11.3l-56.6-56.6zM262 530h-80c-4.4 0-8 3.6-8 8v44c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8v-44c0-4.4-3.6-8-8-8z"></path>
</svg>
    ),
  },
  {
    id: 'stack-2',
    label: '02',
    tierClass: styles.tierMind,
    iconClass: styles.iconViolet,
    title: 'Человек и его голова',
    blocks: [
      {
        subtitle: 'Сознание и выбор',
        text: 'Психология, мораль, этика — всё, на чём стоит цивилизация и стоит ли вообще.',
        tags: ['Коллекционер', 'Жук в муравейнике'],
      },
      {
        subtitle: 'Человек в обществе',
        text: 'Как личность сталкивается с нормами, ожиданиями и чужими взглядами. И как этого избегать.',
        tags: ['Гордость и предубеждение', 'Идиот'],
      },
    ],
    icon: (
      <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M9.5 2A2.5 2.5 0 0 1 12 4.5v15a2.5 2.5 0 0 1-4.96-.46 2.5 2.5 0 0 1-2.96-3.08 3 3 0 0 1-.34-5.58 2.5 2.5 0 0 1 1.32-4.24 2.5 2.5 0 0 1 4.44-1.54" />
        <path d="M14.5 2A2.5 2.5 0 0 0 12 4.5v15a2.5 2.5 0 0 0 4.96-.46 2.5 2.5 0 0 0 2.96-3.08 3 3 0 0 0 .34-5.58 2.5 2.5 0 0 0-1.32-4.24 2.5 2.5 0 0 0-4.44-1.54" />
      </svg>
    ),
  },
  {
    id: 'stack-3',
    label: '03',
    tierClass: styles.tierHeavy,
    iconClass: styles.iconPink,
    title: 'Неподъёмные произведения',
    blocks: [
      {
        subtitle: 'Толстые и плотные',
        text: 'Классика, которую не хотелось читать в одиночку. Или тяжёлый сайфай с сотней слоёв. Или вообще — пьеса.',
        tags: ['Идиот', 'Задача трёх тел'],
      },
      {
        subtitle: 'Многослойные каноны',
        text: 'Тексты с десятком смысловых уровней — разбираем медленно и только там, где лежит душа. Если Пилат не лезет, Пилата не пихаем.',
        tags: ['Мастер и Маргарита', 'Коллекционер'],
      },
    ],
    icon: (
      <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
        <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" />
        <path d="M8 7h8M8 11h6" />
      </svg>
    ),
  },
  {
    id: 'stack-4',
    label: '04',
    tierClass: styles.tierFresh,
    iconClass: styles.iconGreen,
    title: 'Заезженное под новым углом',
    blocks: [
      {
        subtitle: 'Знакомое — заново',
        text: 'Книги, которые все «знают», но редко всматриваются с глубоким вниманием.',
        tags: ['Гордость и предубеждение', 'Вишнёвый сад'],
      },
      {
        subtitle: 'Хиханьки-хаханьки',
        text: 'Чем тяжелее литература, тем больше в ней мемов. Это ещё Конфуций знал.',
        tags: ['Братья Карамазовы'],
      },
    ],
    icon: (
      <svg width="32" height="32" viewBox="64 64 896 896" fill="currentColor">
  <path d="M955.7 856l-416-720c-6.2-10.7-16.9-16-27.7-16s-21.6 5.3-27.7 16l-416 720C56 877.4 71.4 904 96 904h832c24.6 0 40-26.6 27.7-48zm-790.4-23.9L512 231.9 858.7 832H165.3zm319-474.1l-228 394c-12.3 21.3 3.1 48 27.7 48h455.8c24.7 0 40.1-26.7 27.7-48L539.7 358c-6.2-10.7-17-16-27.7-16-10.8 0-21.6 5.3-27.7 16zm214 386H325.7L512 422l186.3 322zm-214-194.1l-57 98.4C415 669.5 430.4 696 455 696h114c24.6 0 39.9-26.5 27.7-47.7l-57-98.4c-6.1-10.6-16.9-15.9-27.7-15.9s-21.5 5.3-27.7 15.9zm57.1 98.4h-58.7l29.4-50.7 29.3 50.7z"></path>
</svg>

    ),
  },
];

export const SectionStack = () => {
  return (
    <section className={styles.sectionStackContainer} id="stack">
      <h2 className={styles.sectionStackTitle}>Что читаем</h2>
      <p className={styles.sectionStackSubtitle}>
        Тематические направления книжного клуба — чем мы тут занимаемся.
      </p>
      <div className={styles.sectionStackCardContainer}>
        {STACK_TOPICS.map((topic) => (
          <article
            key={topic.id}
            className={`${styles.sectionStackCard} ${topic.tierClass}`}
            data-stack-topic={topic.id}
          >
            <div className={styles.cardScanline} aria-hidden="true" />
            <div className={styles.cardCornerTL} aria-hidden="true" />
            <div className={styles.cardCornerBR} aria-hidden="true" />

            <header className={styles.cardHeader}>
              <span className={styles.topicLabel}>{topic.label}</span>
            </header>

            <div className={`${styles.sectionStackCardIcon} ${topic.iconClass}`}>
              {topic.icon}
            </div>

            <h3 className={styles.sectionStackTitleText}>{topic.title}</h3>

            <div className={styles.sectionStackCardInfo}>
              {topic.blocks.map((block, index) => (
                <React.Fragment key={block.subtitle}>
                  {index > 0 && <hr className={styles.customHr} />}
                  <div>
                    <p className={styles.sectionStackCardInfoSubtitle}>{block.subtitle}</p>
                    <p className={styles.sectionStackCardInfoText}>{block.text}</p>
                    <div className={styles.sectionStackCardInfoItemContainer}>
                      {block.tags.map((tag) => {
                // Find the book key by title
                const bookKey = Object.keys(BOOK_TITLES).find(key => BOOK_TITLES[key] === tag);
                const href = bookKey ? `/books#${bookKey}` : '#';
                return (
                  <a key={tag} href={href} className={styles.sectionStackCardInfoItem}>
                    {tag}
                  </a>
                );
              })}
                    </div>
                  </div>
                </React.Fragment>
              ))}
            </div>
          </article>
        ))}
      </div>
    </section>
  );
};
